import React from "react";
import Bluedart from "../../../assets/bluedart.png";
import Delehivery from "../../../assets/delehivery.png";
import EcomExpress from "../../../assets/ecom-expresss.avif";
import Shadowfax from "../../../assets/shadowfax.png";
import Xpressbees from "../../../assets/xpressbees.png";
import Shiprocket from "../../../assets/shiprocket.webp";
import NimbusPost from "../../../assets/nimbuspost.webp";
import ShreeMaruti from "../../../assets/shreemaruti.png";
import DTDC from "../../../assets/dtdc.png";
import Amazon from "../../../assets/amazon.jpg";
import Smartship from "../../../assets/bluedart.png";
import { Link } from "react-router-dom";
import { FaTruck, FaPlane } from "react-icons/fa";
import ThreeDotLoader from "../../../Loader";

import { useState } from "react";

const carrierLogos = {
  Bluedart,
  Delhivery: Delehivery,
  EcomExpress,
  Shadowfax,
  Xpressbees,
  NimbusPost,
  Shiprocket,
  "Shree Maruti": ShreeMaruti,
  ShreeMaruti,
  DTDC,
  Dtdc: DTDC,
  Amazon,
  "Amazon Shipping": Amazon,
  Smartship,
};

const CourierSelectionRate = ({ plan, loading, hasFetched }) => {
  if (hasFetched && (!Array.isArray(plan) || plan.length === 0)) {
    return <p className="text-center py-4 text-gray-600">No Data Found</p>;
  }

  const getCarrierLogo = (courierServiceName) => {
    const lowerName = courierServiceName?.toLowerCase() || "";
    // Find a carrierLogo key that's included in the courierServiceName
    const foundKey = Object.keys(carrierLogos).find((key) =>
      lowerName.includes(key.toLowerCase())
    );
    return foundKey ? carrierLogos[foundKey] : Shadowfax;
  };

  if (hasFetched && loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <ThreeDotLoader />
      </div>
    );
  }

  return (
    <>
      {!hasFetched && plan.length > 0 && (
        <div className="">
          {/* Desktop View */}
          <div className="hidden md:block bg-white shadow rounded-lg p-4">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b text-left bg-[#632C9D] text-white font-[600] text-[12px]">
                    <th className="px-3 py-2">Courier</th>
                    <th className="px-3 py-2 text-center">Mode</th>
                    <th className="px-3 py-2 text-center">Charges</th>
                    <th className="px-3 py-2 text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {plan
                    .sort(
                      (a, b) => a.forward.finalCharges - b.forward.finalCharges
                    )
                    .map((item) => (
                      <tr
                        key={item._id}
                        className="border-b text-gray-700 text-[12px]"
                      >
                        <td className="flex items-center space-x-4 px-3 py-2">
                          <img
                            src={getCarrierLogo(item.courierServiceName)}
                            alt={item.courierServiceName}
                            className="w-12 h-12"
                          />
                          <span>{item.courierServiceName}</span>
                        </td>
                        <td className="text-center px-3 py-2">
                          <div className="flex justify-center">
                            {item.courierType === "Domestic (Air)" ? (
                              <FaPlane className="text-gray-500 text-[18px]" />
                            ) : (
                              <FaTruck className="text-gray-500 text-[18px]" />
                            )}
                          </div>
                        </td>
                        <td className="text-center font-[600] px-3 py-2 text-gray-500">
                          ₹{item.forward.finalCharges}
                        </td>
                        <td className="text-center px-3 py-2">
                          <Link to="/dashboard/order/neworder">
                            <button className="px-3 py-2 bg-[#632C9D] text-white rounded-lg text-[10px] font-[600]">
                              + Create Shipment
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile View */}
          <div className="md:hidden bg-white rounded-lg mt-[-20px] sm:p-4">
            {plan.map((item) => (
              <div
                key={item._id}
                className="bg-white shadow-md rounded-lg p-4 mb-4"
              >
                <div className="flex items-center space-x-4">
                  <img
                    src={getCarrierLogo(item.courierServiceName)}
                    alt={item.courierServiceName}
                    className="w-12 h-12"
                  />
                  <div>
                    <h2 className="text-[10px] font-[600] text-gray-700">
                      {item.courierServiceName}
                    </h2>
                  </div>
                </div>
                <div className="mt-2 space-y-2">
                  <div className="flex justify-between">
                    <p className="text-[10px] font-[600] text-gray-500">
                      Mode:
                    </p>
                    <div className="text-[12px]">
                      {item.courierType === "International" ? (
                        <FaPlane className="text-gray-500 text-[12px]" />
                      ) : (
                        <FaTruck className="text-gray-500 text-[12px]" />
                      )}
                    </div>
                  </div>
                  <div className="flex justify-between font-[600] text-[10px] text-gray-500">
                    <span>Charges:</span>
                    <span className="font-[600] text-gray-500">
                      ₹{item.forward.finalCharges}
                    </span>
                  </div>
                </div>
                <div className="mt-2 flex justify-center">
                  <Link to="/dashboard/order/neworder">
                    <button className="w-full py-2 px-3 bg-[#632C9D] text-white rounded-lg text-[10px] font-[600]">
                      + Create Shipment
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CourierSelectionRate;
